import { createApi, FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import {
  CreateCampaignUserRequest,
  CreateCampaignUserResponse,
  CreateNewUserRequest,
  LandingPageAPIPayload,
  LandingPageNullProductResponse,
  LandingpageProductResponse,
  RegisterCarRequest,
  RegisterCarResponse,
} from '@shared/types/campaigns';
import fetchBaseQuery from '@utilities/fetchBaseQuery';
import { SerializedError } from '@reduxjs/toolkit';

export const CampaignApi = createApi({
  reducerPath: 'CampaignApi',
  baseQuery: fetchBaseQuery,
  endpoints: (builder) => ({
    getLandingpage: builder.query<
      LandingPageNullProductResponse | LandingpageProductResponse,
      LandingPageAPIPayload
    >({
      query: ({ landingpageId, product }) => ({
        url: `landing-pages/get/${landingpageId}`,
        method: 'POST',
        body: { product: product || null },
      }),
    }),

    createUser: builder.mutation<
      CreateCampaignUserResponse,
      CreateCampaignUserRequest
    >({
      query: (body) => ({
        url: '/landing-pages/new-member',
        method: 'POST',
        body,
      }),
    }),

    createNewUser: builder.mutation<
      CreateCampaignUserResponse,
      CreateNewUserRequest
    >({
      query: (body) => ({
        url: '/user',
        method: 'POST',
        body,
      }),
    }),

    registerCars: builder.mutation<
      | RegisterCarResponse 
      | { error: FetchBaseQueryError | SerializedError },
      RegisterCarRequest
    >({
      query: (body) => ({
        url: '/car/register',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useGetLandingpageQuery,
  useCreateUserMutation,
  useCreateNewUserMutation,
  useRegisterCarsMutation,
} = CampaignApi;
